import FetchClient, { type ApiResponse } from "./FetchClient";

export const STORE_PRODUCTION_RETAILERS = [
  "walmart",
  "home_depot",
  "dollar_general",
  "target",
  "bestbuy",
  "lowes",
] as const;

export type StoreProductionRetailer = (typeof STORE_PRODUCTION_RETAILERS)[number];

export const STORE_PRODUCTION_RETAILER_LABELS: Record<StoreProductionRetailer, string> = {
  walmart: "Walmart",
  home_depot: "Home Depot",
  dollar_general: "Dollar General",
  target: "Target",
  bestbuy: "Best Buy",
  lowes: "Lowe's",
};

export interface StoreProductionDay {
  storeId: string;
  productsUploaded: number;
  totalProductsFirstInserted: number;
  averageDiscount: number;
  usersSearched: number;
  categoriesExpected: number;
  categoriesFound: number;
}

export interface StoreProductionSnapshot {
  date: string;
  available: boolean;
  totalProducts: number;
  storesReported: number;
  storesExpected: number;
  stores: StoreProductionDay[];
  /** The user's products after merging the same UPC across stores, as on the products page. */
  uniqueProducts?: number;
}

export interface StoreProductionHistory {
  retailer: StoreProductionRetailer;
  days: number;
  generatedAt: number;
  fromDate: string;
  throughDate: string;
  storeIds: string[];
  availableStoreIds: string[];
  snapshots: StoreProductionSnapshot[];
}

export async function getStoreProductionHistory({
  retailer = "walmart",
  days = 7,
  storeIds = [],
  userId,
}: {
  retailer?: StoreProductionRetailer;
  days?: number;
  storeIds?: string[];
  userId?: string;
} = {}): Promise<StoreProductionHistory> {
  const params = new URLSearchParams({ retailer, days: String(days) });
  if (userId) {
    params.set("userId", userId);
  }
  const normalizedStoreIds = [...new Set(storeIds.map((storeId) => storeId.trim()).filter(Boolean))];
  if (normalizedStoreIds.length > 0) {
    params.set("storeIds", normalizedStoreIds.join(","));
  }
  const response = await FetchClient.get<ApiResponse<StoreProductionHistory>>(
    `/admin/store-production-history?${params.toString()}`,
  );
  return response.data;
}
